import { Avatar, Tooltip } from "antd";
import company_placeholder from "../../img/company_placeholder.png";

export default function AvatarGroup({ meet, table = false }: any) {
  let hours = new Date(meet.date).getHours();
  let minutes = new Date(meet.date).getMinutes();

  return (
    <>
      <Avatar.Group
        maxCount={2}
        maxStyle={{ color: "#f56a00", backgroundColor: "#fde3cf" }}
      >
        <Tooltip
          title={
            meet?.client?.company
              ? meet?.client?.company?.name
              : meet?.client?.name
          }
          placement="top"
          overlayInnerStyle={{ background: "white", color: "black" }}
        >
          <Avatar
            size={15}
            src={
              meet?.client?.company
                ? meet?.client?.company?.logo
                  ? process.env.REACT_APP_STORAGE_URL +
                    meet?.client?.company?.logo
                  : company_placeholder
                : company_placeholder
            }
          />
          {/* <Tooltip
            title={meet.client.name}
            placement="top"
            overlayInnerStyle={{
              background: "white",
              color: "black",
            }}
          >
            <Avatar
              size={20}
              src={
                meet.client.logo
                  ? process.env.REACT_APP_STORAGE_URL + meet.client.logo
                  : avatar_placeholder
              }
            />
          </Tooltip> */}
        </Tooltip>
      </Avatar.Group>
      {!table && (
        <div>
          <span>{meet.subject} </span>
          <br />
          <span>
            {hours} : {minutes} ({meet.duration} h)
          </span>
        </div>
      )}
    </>
  );
}
